import { CommunityMember } from '../types';

export const mockCommunityMembers: CommunityMember[] = [
  {
    id: '750e8400-e29b-41d4-a716-446655440001',
    firstName: 'James',
    lastName: 'Anderson',
    email: 'james.anderson@email.com',
    phone: '555-0201',
    address: '111 Community Drive',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62707',
  },
  {
    id: '750e8400-e29b-41d4-a716-446655440002',
    firstName: 'Patricia',
    lastName: 'Martinez',
    email: 'patricia.martinez@email.com',
    phone: '555-0202',
    address: '222 Volunteer Lane',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62708',
  },
];
